async function loadCartItems() {
  const cart = await fetch("/cart.js").then((res) => res.json());
  const container = document.getElementById("cart-items-container");
  const total = document.getElementById("cart-total-price");

  const metafieldsMapEl = document.getElementById("product-metafields-map");
  const productMetafields = metafieldsMapEl
    ? JSON.parse(metafieldsMapEl.textContent)
    : {};

  let html = "";

  cart.items.forEach((item) => {
    const metafields = productMetafields[item.product_id] || {};
    const collectionHandle = metafields.collection_handle || null;

    const optionsList =
      item.options_with_values
        ?.map((opt) => `${opt.name} ${opt.value}`)
        .join(", ") || "";

    let imgSrc = item.image ? item.image : productPlaceholder;

    html += `
      <div class="cart-item" data-line-id="${item.id}" data-line-key="${
      item.key
    }">
        <div class="cart-item__image">
          <img src="${imgSrc}" alt="${item.title}">

        </div>
        <div class="cart-item__info">
          <div class="cart-item__collection">
            ${item.vendor}
          </div>
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__variant">${optionsList}</div>
          <div class="cart-item__quantity">
            <button class="qty-minus">
              <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L-5.96046e-08 0.999999" stroke="#A89898"/>
              </svg>
            </button>
            <span>${item.quantity}</span>
            <button class="qty-plus">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 0V12" stroke="#A89898"/>
                <path d="M12 6L-5.96046e-08 6" stroke="#A89898"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="cart-item__actions">
          <button class='st-wishlist-button' data-type='details' data-handle='${
            item.handle
          }'></button>
          <button type="button" class="cart-remove" aria-label="Remove Item">
             <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_719_6662)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27485 5.99866L11.9434 0.330143L11.6697 0.0565186L6.00122 5.72503L0.332706 0.0565186L0.059082 0.330143L5.7276 5.99866L0.059082 11.6672L0.332706 11.9408L6.00122 6.27228L11.6697 11.9408L11.9434 11.6672L6.27485 5.99866Z" fill="#323232"/>
              </g>
              <defs>
                <clipPath id="clip0_719_6662">
                  <rect width="12" height="12" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </button>
          <div class="cart-item__price">
            ${(item.final_line_price / 100).toFixed(2)} ${cart.currency}
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  total.textContent = (cart.total_price / 100).toFixed(2) + " " + cart.currency;

  const finalTotalEl = document.getElementById("cart-final-total");
  const discountWrapper = document.querySelector(".cart-drawer__discount");

  const formatMoney = (amount, currency) =>
    `${(amount / 100).toFixed(2)} ${currency}`;

  if (cart.total_discount > 0) {
    finalTotalEl.textContent = formatMoney(cart.total_price, cart.currency);
    discountWrapper.style.display = "flex";
  } else {
    discountWrapper.style.display = "none";
  }

  setupQuantityButtons(cart);
  setupRemoveButtons(cart);
  updateHeaderCartCount(cart.item_count);

  if (
    window.SWishlist &&
    typeof window.SWishlist.updateButtonsWatcher === "function"
  ) {
    window.SWishlist.updateButtonsWatcher(container);
  }

  // Возвращаем true, если есть товары, иначе false
  return cart.items.length > 0;
}

function setupQuantityButtons(cart) {
  document.querySelectorAll(".cart-item").forEach((itemEl) => {
    const minusBtn = itemEl.querySelector(".qty-minus");
    const plusBtn = itemEl.querySelector(".qty-plus");
    const quantityContainer = itemEl.querySelector(".cart-item__quantity");
    const itemKey = itemEl.dataset.lineKey;
    const item = cart.items.find((i) => i.key === itemKey);

    if (!item) return;

    let spinnerEl = null;

    function showLoading() {
      itemEl.classList.add("is-loading");
      spinnerEl = document.createElement("div");
      spinnerEl.className = "spinner";
      quantityContainer.appendChild(spinnerEl);
    }

    function hideLoading() {
      itemEl.classList.remove("is-loading");
      if (spinnerEl && spinnerEl.parentNode) {
        spinnerEl.remove();
        spinnerEl = null;
      }
    }

    minusBtn.addEventListener("click", () => {
      if (item.quantity > 1) {
        showLoading();
        updateCartQuantity(item.key, item.quantity - 1).finally(hideLoading);
      }
    });

    plusBtn.addEventListener("click", () => {
      showLoading();
      fetch(`/products/${item.handle}.js`)
        .then((res) => res.json())
        .then(() => updateCartQuantity(item.key, item.quantity + 1))
        .catch(() => updateCartQuantity(item.key, item.quantity + 1))
        .finally(hideLoading);
    });
  });
}

function updateCartQuantity(key, quantity) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: key, quantity }),
  })
    .then((res) => {
      if (!res.ok) {
        return res.json().then((err) => Promise.reject(err));
      }
      return res.json();
    })
    .then(() => {
      return loadCartItems();
    })
    .catch((error) => {
      const message = error.description || "Something went wrong";

      const itemEl = document.querySelector(`[data-line-key="${key}"]`);
      if (!itemEl) return;

      let msg = itemEl.querySelector(".cart-error-message");
      if (!msg) {
        msg = document.createElement("div");
        msg.className = "cart-error-message";
        itemEl.querySelector(".cart-item__quantity").after(msg);
      }

      msg.textContent = message;
    });
}

function setupRemoveButtons(cart) {
  document.querySelectorAll(".cart-item").forEach((itemEl) => {
    const removeBtn = itemEl.querySelector(".cart-remove");
    const itemKey = itemEl.dataset.lineKey;

    if (!removeBtn || !itemKey) return;

    removeBtn.addEventListener("click", () => {
      itemEl.classList.add("removing");

      setTimeout(() => {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: itemKey, quantity: 0 }),
        })
          .then((res) => res.json())
          .then(async () => {
            const hasItems = await loadCartItems();
            if (!hasItems) {
              toggleCartDrawer(false); // Закрываем drawer, если корзина пуста
            }
          });
      }, 300);
    });
  });
}

function updateHeaderCartCount(count) {
  const cartIcon = document.querySelector("#cart-icon-bubble");
  if (!cartIcon) return;

  const existingBubble = cartIcon.querySelector(".cart-count-bubble");
  if (existingBubble) {
    existingBubble.remove();
  }

  if (count > 0) {
    const bubble = document.createElement("div");
    bubble.className = "cart-count-bubble";
    bubble.innerHTML = `
      <span aria-hidden="true">${count}</span>
      <span class="visually-hidden">${count} item${
      count !== 1 ? "s" : ""
    }</span>
    `;
    cartIcon.appendChild(bubble);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  loadCartItems();

  document.querySelectorAll(".header__icon--cart").forEach((icon) => {
    icon.addEventListener("click", async (e) => {
      e.preventDefault();

      const hasItems = await loadCartItems(); // true/false
      toggleCartDrawer(hasItems);
    });
  });

  // document.querySelectorAll(".product-button-buy").forEach((icon) => {
  //   icon.addEventListener("click", async (e) => {
  //     e.preventDefault();

  //     setTimeout(async () => {
  //       const hasItems = await loadCartItems(); // true/false
  //       toggleCartDrawer(hasItems);
  //     }, 2000);
  //   });
  // });
});

function toggleCartDrawer(cartHasItems) {
  const emptyCartModal = document.querySelector(".cart-drawer-empty-js");
  const drawer = document.getElementById("custom-cart-drawer");

  // Показываем нужное окно в зависимости от наличия товаров
  if (cartHasItems) {
    drawer.classList.add("open");
    emptyCartModal?.classList.remove("open");
  } else {
    emptyCartModal?.classList.add("open");
    drawer.classList.remove("open");
  }
}

const emptyCartModal = document.querySelector(".cart-drawer-empty-js");
document.addEventListener("click", (e) => {
  if (!emptyCartModal?.classList.contains("open")) return;

  // Проверяем, что клик был вне модального окна
  if (!emptyCartModal.contains(e.target)) {
    emptyCartModal.classList.remove("open");
  }
});

window.addEventListener("scroll", function () {
  emptyCartModal.classList.remove("open");
});

document
  .getElementById("btn--oneclick")
  ?.addEventListener("click", async () => {
    const cart = await fetch("/cart.js").then((res) => res.json());
    document.getElementById("cart-json-field").value = JSON.stringify(cart);
    document.getElementById("oneclick-modal").classList.remove("hidden");
  });

function closeOneClickModal() {
  document.getElementById("oneclick-modal").classList.add("hidden");
}
